import React from 'react';
import '../CheckinInfo.css';
import {TimePicker} from '@mui/x-date-pickers';
import Select from 'react-select';
import CheckinInfoGraph from './CheckinInfoGraph';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import {MDBCheckbox} from 'mdb-react-ui-kit';

/**
 * La vue de l'update du checkin
 * @param {*} props props
 * @return {JSX}
 */
function CheckinInfoView(props) {
  return (
    <>
      <form className="form" onSubmit={props.handleSubmit}>
        <div className="updatecheckin-wrapper">
          <span className="employe-close float-end" onClick={() => props.back()} style={{marginRight: '10px'}}>
          &times;
          </span>
          <button style={{fontSize: '28px'}} type="button" className="float-start checkin-pagination-button" onClick={() => props.handleDelete()}><FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon></button>
        </div>
        <h3 style={{color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-20px'}}>Modifier un checkin</h3>
        <div className="app" style={{textAlign: 'center'}}>
          <label className="addcheckin-labelchantier">Voir tout les projets?</label>
          <div className="toggle-switch">
            <div>
              <input
                type="checkbox"
                id="toggle"
                checked={props.checkedChantier}
                onChange={props.handleChantierCheckBox} />
              <label htmlFor="toggle"></label>
            </div>
          </div>
        </div>
        <div style={{marginTop: '18px'}}>
          <Select
            name="Chantiers"
            options={props.placeName}
            onChange={ (e) => props.handleChange(e, 'chantier')}
            classNamePrefix="select"
            placeholder="Projets"
            defaultValue={props.form.chantier} />
        </div>
        {props.form.errorsForm && props.form.errorsForm.chantier && (
          <span className="error">{props.form.errorsForm.chantier}</span>
        )}
        <div className="form-group">
          <input
            id="date"
            className="form-control"
            type="date"
            value={props.form.date}
            onChange={props.handleDateChange} />
        </div>
        {props.form.errorsForm && props.form.errorsForm.date && (
          <span className="error">{props.form.errorsForm.date}</span>
        )}
        <div className="form-group">
          <Select
            id="values"
            className="form-control"
            isMulti
            value={props.form.employer}
            onChange={(e) => props.handleChange(e, 'employer')}
            options={props.usernames}
            placeholder="Employées">
          </Select>
        </div>
        <div className="app" style={{textAlign: 'center', marginTop: '22px'}}>
          <label className="addcheckin-labeltransport">Transport?</label>
          <div className="toggle-switch">
            <div>
              <input
                type="checkbox"
                id="toggleTransport"
                name="transport"
                checked={props.form.transport}
                onChange={props.handleChangeCheckBox} />
              <label htmlFor="toggleTransport"></label>
            </div>
          </div>
        </div>
        <div style={{color: 'white', marginTop: '15px'}}>
          <MDBCheckbox name='extra1' id='inlineCheckbox111111' value='option1' label='Extra possible' defaultChecked={props.form.extra1} onChange={props.handleChangeCheckBox} inline />
          {localStorage.getItem('admin') === '1' ?
          <React.Fragment>
            <MDBCheckbox name='extra2' id='inlineCheckbox222222' value='option2' label='Extra valider' defaultChecked={props.form.extra2} onChange={props.handleChangeCheckBox} inline />
            <MDBCheckbox name='extra3' id='inlineCheckbox333333' value='option3' label='Extra confirmer' defaultChecked={props.form.extra3} onChange={props.handleChangeCheckBox} inline />
          </React.Fragment> : ''}
        </div>
        <div className="form-group">
          <textarea
            id="note"
            className="form-control"
            value={props.form.note == null ? '' : props.form.note}
            onChange={props.handleNoteChange}
            placeholder="Note" />
        </div>
        <div className="form-group">
          <div className="form-group-inline form-group-inline-label">
            <div className="form-group-inline-item">
              <TimePicker
                label="Check-in"
                value={props.form.checkin}
                onChange={ (e) => props.handleChange(e, 'checkin')}
                ampm={false}
                sx={{
                  'width': 220,
                  '& input': {color: 'white'},
                  '& label': {color: 'white', fontSize: '20px'},
                  '& button': {color: 'white', fontSize: '25px'},
                }} />
            </div>
            <div className="form-group-inline-item">
              <TimePicker
                label="Check-out"
                value={props.form.checkout}
                onChange={ (e) => props.handleChange(e, 'checkout')}
                ampm={false}
                sx={{
                  'width': 220,
                  '& input': {color: 'white'},
                  '& label': {color: 'white', fontSize: '20px'},
                  '& button': {color: 'white', fontSize: '25px'},
                }} />
            </div>
          </div>
        </div>
        {props.form.errorsForm && props.form.errorsForm.heure && (
          <span className="error">{props.form.errorsForm.heure}</span>
        )}
        {props.form.checkin !== null && props.form.checkout !== null && props.form.checkin < props.form.checkout ?
          <CheckinInfoGraph startend={props.startend} taches={props.taches} setTaches={props.setTaches} nbHeures={props.nbHeures}/> : ''}
        <button type="submit" className="btn btn-primary" style={{backgroundColor: '#0d6efd', color: 'white'}}>
        Enregistrer
        </button>
      </form>
    </>
  );
}

export default CheckinInfoView;
